import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from "@chakra-ui/react"
import { FC, MouseEventHandler, ReactNode } from "react"
import { PlansPageStyling } from "src/context/types"
import usePageStyling from "src/hooks/usePageStyling"

export const PopupModal = ({
  isOpen,
  onClose,
  title,
  description,
  branding,
  action
}: {
  isOpen: boolean
  onClose: () => void
  title: string
  description: string
  branding: PlansPageStyling
  action?: ReactNode
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xs">
      <ModalOverlay />
      <ModalContent
        color={branding?.planPagePanelTextColor}
        bg={branding?.planPageBackgroundColor}
        border={"yellow 1px solid"}
        // bg={branding?.planPageButtonBackgroundColor ?? "#1AC541"}
      >
        <ModalHeader
        // textColor={branding?.planPageButtonTextColor ?? "#FFFFFF"}
        >
          {title}
        </ModalHeader>
        <ModalCloseButton _focus={{}} />

        <ModalBody>
          <Text
            // textColor={branding?.planPageButtonTextColor ?? "#FFFFFF"}
            textAlign="justify"
          >
            {description}
          </Text>
        </ModalBody>
        <ModalFooter>{action}</ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export const PopupModalButton: FC<{
  onClick: () => void
  background?: string
  color?: string
}> = ({ children, ...props }) => {
  const plansPageStyles: PlansPageStyling = usePageStyling("plansPageStyling")
  console.log(plansPageStyles)
  return (
    <Button
      _hover={{ filter: "brightness(50%)" }}
      _focus={{}}
      _active={{ filter: "brightness(50%)" }}
      background={plansPageStyles?.planPageButtonBackgroundColor}
      color={plansPageStyles?.planPageBackgroundColor}
      {...props}
    >
      {children}
    </Button>
  )
}
